export const EXPORT_REPORT = (providerId: any) => `/pdf/generate/benchamarking/${providerId}`;
export const GET_PDF_URL = (id: any) => `/pdf/url/${id}`;
export const GET_EXPORT_JOB = (id: any) => `/public/export-jobs/${id}`;
export const FETCH_REPORT_DATA = (id: any) => `/masterProviders/benchmarking/data/${id}`;
export const REQUEST_VFM_REPORT = `/masterProviders/sendmail`;
